// extracted by mini-css-extract-plugin
export default {"requirement_chip":"RequirementChip_requirement_chip__YN593"};